import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import * as React from "react";
import { Box } from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { ViewCountryHeadCountWrapper } from "./SimpleDialogStyled";
import Checkbox from "@mui/material/Checkbox";
import { Troubleshoot } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import TableSortLabel from "@mui/material/TableSortLabel";
const SimpleDialog = ({ headers, rows, open, close, }) => {
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState("countryName");
  const createSortHandler = (property) => (event) => {
      setOrder(order == 'asc' ? 'desc' : 'asc');
      setOrderBy(property);
  };
  function descendingComparator(a, b, orderBy) {
      if (b[orderBy] < a[orderBy]) {
          return -1;
      }
      if (b[orderBy] > a[orderBy]) {
          return 1;
      }
      return 0;
  }

  function getComparator(order, orderBy) {
      return order === 'desc'
          ? (a, b) => descendingComparator(a, b, orderBy)
          : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
      const stabilizedThis = array.map((el, index) => [el, index]);
      stabilizedThis.sort((a, b) => {
          const order = comparator(a[0], b[0]);
          if (order !== 0) {
              return order;
          }
          return a[1] - b[1];
      });
      return stabilizedThis.map((el) => el[0]);
  }
  return (
    <>
      <ViewCountryHeadCountWrapper
        onClose={close} open={open} scroll="paper"
        maxWidth="xs"
        fullWidth={true}>
        {/* <DialogTitle className="customDialogTitle">
            <IconButton
              edge="end"
              color="inherit"
              onClick={close}
              aria-label="close"
             
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle> */}
        <DialogContent class="customDialog">
          {headers.length > 0 && rows.length > 0 &&

            <Table stickyHeader aria-label="simple table">
              <TableHead sx={{ borderBottom: "2px solid #1B4A83" }}>
                <TableRow>
                  <TableCell key={headers[0].id}>{headers[0].label}
                  {<TableSortLabel
                                            active={orderBy === headers[0].id}
                                            direction={orderBy === headers[0].id ? order : 'asc'}
                                            onClick={createSortHandler(headers[0].id)}>
                                        </TableSortLabel>}</TableCell>
                  <TableCell key={headers[1].id}>
                    <div>
                      {headers[1].label}{<TableSortLabel
                                            active={orderBy === headers[1].id}
                                            direction={orderBy === headers[1].id ? order : 'asc'}
                                            onClick={createSortHandler(headers[1].id)}>
                                        </TableSortLabel>}
                      <IconButton edge="end" sx={{ marginLeft: "5px" }} color="inherit" onClick={close} aria-label="close" >
                        <CloseIcon />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody sx={{ border: "1px solid #1B4A83" }}>
                {stableSort(rows, getComparator(order, orderBy)).map((row, index) => (
                  <TableRow key={index}>
                    {headers.map((cell) => (
                      isNaN(row[cell.id]) ? (
                        <TableCell key={cell.id} sx={{ fontWeight: 600, wordBreak:"break-all",maxWidth:'130px' }} align="right">
                          {row[cell.id]}
                        </TableCell>) :

                        <TableCell key={cell.id} align="right">
                          {(row[cell.id]).toLocaleString()}
                        </TableCell>
                    ))}
                  </TableRow>
                ))}


              </TableBody>
            </Table>
          }
        </DialogContent>

      </ViewCountryHeadCountWrapper>
    </>
  );
};

export default SimpleDialog;
